const wsAsyncRequestProvider
  = require('mn-utils/browser/wsAsyncRequestProvider');
const noopHandle = require('mn-utils/noopHandle');
const extend = require('mn-utils/extend');
const CancelablePromise = require('mn-utils/CancelablePromise');
const config = require('../config/api');
const {
  handleReconnectMerchant,
  handleReconnectAdmin,
} = require('./_auth');
const {
  openPopupError,
} = require('../emitters/popup');


function apiRequestProvider(wsUrl, options) {
  const wsRequest = wsAsyncRequestProvider(wsUrl, options);
  function instance(apiMethod, params, handleMock) {
    params = params
      ? {...params}
      : {};
    const skipError = params.skipError;
    const handleError = params.handleError;
    if (skipError) {
      delete params.skipError;
    }
    if (handleError) {
      delete params.handleError;
    }
    return (
      process.env.MOCK
        ? CancelablePromise.delay(1000, {}).then(
          handleMock
            ? () => handleMock(params) || {}
            : noopHandle,
        )
        : wsRequest(apiMethod, params).then((data) => {
          const {
            error,
          } = data;
          if (error) {
            throw error;
          }
          return data.response;
        })
    )
        .catch((error) => {
          if (handleError) {
            return handleError(error);
          }
          throw error;
        })
        .catch((error) => {
          skipError || openPopupError(error.message || 'Connection error');
          throw error;
        });
  }
  extend(instance, wsRequest);
  return instance;
}

export const apiRequest = apiRequestProvider(config.API_URL_WS, {
  onMessage(value) {
    const {
      notification,
    } = value;
    if (notification) {
      return false;
    }
  },
  onError(error) {
    // console.error('wsAsyncRequest onError', error);
  },
  onSuccessConnect() {
    // console.log('onSuccessConnect');
  },
  onReconnect: handleReconnectMerchant,
  /*
  onReconnect(error) {
    console.error('wsAsyncRequest onReconnect', error);
    // console.log('onReconnect', error.message);
    return checkSession(error);
  },
 */
});

export const apiRequestAdmin = apiRequestProvider(config.API_URL_WS_ADMIN, {
  onReconnect: handleReconnectAdmin,
});
